/**
 * A trucking quote can be brokered — 7L returns the broker as a token on the rate, e.g.
 * `"AAA Cooper % LRD"`. There is no column for it, so it rides in the quote variant's name and is
 * read back out for display. Square brackets are the delimiter because the name already uses
 * parentheses for the delivery-date label, and admin appends ` (type)` on top of that.
 */
const BROKER_LABEL = /\[([^\]]+)\]/;

/** Appends the broker token to a quote variant name; returns `name` untouched when there is none */
export const withBrokerLabel = (name: string, broker?: string) => {
  const token = broker?.trim();

  return token ? `${name} [${token}]` : name;
};

/**
 * Reads the broker token back out of a quote variant name. Variant names are editable in admin, so
 * this deliberately fails soft — an edited name simply yields `undefined` rather than a wrong token.
 */
export const brokerFromVariantName = (name?: string | null) => {
  return name?.match(BROKER_LABEL)?.[1]?.trim() || undefined;
};
